import { Navigate, useLocation, useParams } from 'react-router-dom';

import { legacyIntakeStatusPath } from './adminJourneyRouting';

export function LegacyIntakeStatusRedirect() {
  const { organizationId = '' } = useParams();
  const { search } = useLocation();
  return <Navigate replace to={legacyIntakeStatusPath(organizationId, search)} />;
}
